import { render, staticRenderFns } from "./ImgFallback.vue?vue&type=template&id=58535987&"
import script from "./ImgFallback.vue?vue&type=script&lang=js&"
export * from "./ImgFallback.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('58535987')) {
      api.createRecord('58535987', component.options)
    } else {
      api.reload('58535987', component.options)
    }
    module.hot.accept("./ImgFallback.vue?vue&type=template&id=58535987&", function () {
      api.rerender('58535987', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-8JzuhB2N9G6vH/JS/comp/ImgFallback.vue"
export default component.exports